import { Vue, Component } from 'vue-property-decorator';
import * as facetWidgets from 'facets-search-widgets';
import { sessionService } from '@/providers/services/auth/session';
import CatalogPullOut from '../cards/catalog-pull-out/catalog-pull-out.vue';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
  name: 'navigator-widget-ui',
  components: {
    'catalog-pull-out': CatalogPullOut,
  },
})
export default class NavigatorWidgetUI extends Vue {

  // ----------------------------------------------------------
  // Properties

  private get session() {
    return sessionService.getSession();
  }

  private get appConfig() {
    return appConfigService.getAppConfig();
  }

  public collectionData: any = null;

  // ------------------------------------------------------------
  // Hooks

  public mounted() {
    const facetQueryParams = JSON.parse(localStorage.getItem('facetQueryParams') || '{}');
    const configDetail = {
      endpoint: appConfigService.getApiUrl(),
      sessionToken: this.session!.access_token,
      contentCdn: this.session!.cdn_urls!.content_cdn_url,
      userCdn: this.session!.cdn_urls!.user_cdn_url,
      role: 'teacher',
      avatarUrl: this.session!.thumbnail_url,
      userId: this.session!.user_id,
      isDeepLink: false,
      isPermission: this.session!.permissions,
      environmentCopy: appConfigService.getEnvironmentCopy(),
      isFacet: localStorage.getItem('isFacet') === 'true',
      facetQueryParams,
      podcastCdnUrl: this.appConfig!.podcastCdnUrl,
      podcastNileUrl: this.appConfig!.podcastNileUrl,
      session: this.session,
      tenantId: this.session!.tenant!.tenant_id,
    };
    facetWidgets.setOption('configDetail', configDetail);
    facetWidgets.mounted('#navigator-widget-ui');
    this.onLoadEvents();
  }


  private openPullout(content: any) {
    this.collectionData = content;
    (this.$el.querySelector('.catalog-pull-out-container') as HTMLElement).style.left = 'calc(100vw - 450px)';
  }

  // -------------------------------------------------------
  // Methods

  private onLoadEvents() {
    const eventData = facetWidgets.eventData();
    eventData.$on('onPlayContent', (content: any) => {
      const id = content.id || content.gooruOid;
      const format = content.type || content.contentFormat || content.format;
      const playerURL = this.buildPlayerUrl(id, format);
      if (localStorage.getItem('isFacet') === 'true') {
        window.open(playerURL, '_self');
      } else {
        window.open(playerURL, '__blank');
      }
    });

    eventData.$on('onEditContent', (content: any) => {
      const currentRoute = this.$router.currentRoute.path;
      const id = content.id || content.gooruOid;
      const format = content.type || content.contentFormat || content.format;
      let playerURL = `${window.location.origin}/library/content/${format}s/edit/${id}?editing=true&redirectUrl=${currentRoute}`;
      if (format === 'offline-activity') {
        playerURL = `${window.location.origin}/library/content/activity/edit/${id}?editingContent=true&isFromOA=true&redirectUrl=${currentRoute}`;
      } else if (format === 'rubric') {
        playerURL = `${window.location.origin}/library/content/rubric/edit/${id}?editingContent=true&redirectUrl=${currentRoute}`;
      }
      window.location.href = playerURL;
    });

    eventData.$on('openPullout', (content: any) => {
      content.id = content.id || content.gooruOid;
      content.type = content.type || content.contentFormat || content.format;
      this.openPullout(content);
    });

    eventData.$on('onSelectContentType', (activeType: any) => {
      this.onCreateContent(activeType.key);
    });
  }

  private buildPlayerUrl(id: string, format: string) {
    let baseUrl = window.location.origin;
    if (['collection', 'assessment'].indexOf(format) !== -1) {
      baseUrl += `/library/player/${id}?source=rgo&type=${format}`;
    } else if (['resource', 'question', 'course'].includes(format)) {
      baseUrl += `/library/content/${format}s/play/${id}?source=rgo`;
    } else {
      baseUrl += `/library/player-offline-activity/${id}?isPreview=true&role=teacher&source=rgo`;
    }
    return baseUrl;
  }


  private onCreateContent(type: any = null) {
    const currentRoute = this.$router.currentRoute.path;
    if (type === 'offline-activity') {
      window.location.href = `/library/content/activity/edit/new?isFromOA=true&redirectUrl=${currentRoute}`;
    } else {
      if (type === 'bulk-upload') {
        window.location.href = `/catalog/my-content/bulk-upload?type=my-content&redirectUrl=${currentRoute}`;
      } else if (type === 'request-upload') {
        window.location.href = `/catalog/my-content/request-upload?type=my-content&redirectUrl=${currentRoute}`;
      } else if (type === 'rubric') {
        window.location.href = `/library/content/${type}/edit/new?redirectUrl=${currentRoute}`;
      } else {
        window.location.href = `/library/content/${type}s/edit/new?redirectUrl=${currentRoute}`;
      }
    }
  }

}
